import ApiClient from './ApiClient';

class ContactTasks extends ApiClient {
  constructor() {
    super('tasks', { accountScoped: true });
    this.contactId = null;
  }

  get url() {
    return `${this.baseUrl()}/contacts/${this.contactId}/tasks`;
  }

  get(contactId) {
    this.contactId = contactId;
    return super.get();
  }

  create(contactId, taskParams) {
    this.contactId = contactId;
    return super.create(taskParams);
  }

  update(contactId, id, taskParams) {
    this.contactId = contactId;
    return super.update(id, taskParams);
  }

  delete(contactId, id) {
    this.contactId = contactId;
    return super.delete(id);
  }
}

export default new ContactTasks();
